/* Yellow Web Monkey. 2025 */

Object.defineProperty(String.prototype, 'capitalize', {
    value: function() {
      return this.charAt(0).toUpperCase() + this.slice(1);
    },
    enumerable: false
  });
  Object.defineProperty(String.prototype, 'depluralize', {
    value: function() {
      let lastChar = this.substring(this.length-1)
      if (lastChar=="s" || lastChar=="S") {
        return this.substring(0,this.length-1)
      }
      return this
    },
    enumerable: false
  });
  class YWM {
    api_version = "2025-10";
    defaults() {
        return {}
    }
    constructor(opts={}) {
        this.config = {...this.defaults(),...opts};
        this.errors=[];
        this.data = {
          settings:this.loadJSON("settings")
        }
        this.requires().forEach(field=>{
          if (!field in this.config) {
            this.errors.push(`Missing Required config field: ${field}`)
          }
        });
        if (this.errors.length>0) {
          throw new Error(this.errors.join("\n"));
        }
        this.observers = {}
    }
    DOMTarget() {
        return document.querySelector("body");
    }
    EventTarget() {
        return this.DOMTarget().querySelector(".content");
    }
    dispatchEvent(thisEventName,detail=null) {
        
        this.EventTarget()?.dispatchEvent(
            new CustomEvent(
                thisEventName,
                {bubbles:true,detail:detail}
            )
        )
    }
    listenFor(eventName,callBack=null) {
        this.EventTarget().addEventListener(
            this.eventName(eventName),
            event=>{
                
                if (callBack) {
                    callBack(event);
                }
                event.stopPropagation()
            }
        )
    }
    eventsPrefix() {
        return `ywm:${this.DOMTarget()?.dataset.identifier||"generic"}`;
    }
    eventName(eventName) {
        return `${this.eventsPrefix()}:${eventName}`
    }
    requires() {
      return []
    }
    defaults() {
      return {
        api_version:"2025-10",
        siteRoot:'',
      };
    }
    log(value) {
      if (this.data.settings.debug) {
        console.error(value)
      }
    }
    loadJSON(identifier) {
      let scriptTag = document.querySelector(`[data-for="${identifier}"]`);
      if (scriptTag==null) {
        return;
      }
      return JSON.parse(scriptTag.textContent);  
    }
    loadBlocksJson(identifier) {
        let data = {};
        
        this.loadJSON(identifier)?.forEach(block=>{
            let blockType = Object.keys(block)[0]
            if (data[blockType]) {
                data[blockType].push(block[blockType]);
            } else {
                data[blockType] = [block[blockType]];
            }
        });
        return data;
    }
    static formatMoney(amount) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(amount)
    }
    static sortArrayofObjects(objects,sortKey) {
        return objects.sort((a,b)=>a[sortKey].localeCompare(b[sortKey]))
    }
    fetch(url,config) {
        if (this.config.fetch_function) {
        return pure_fetch(url,config)
      } else {
        return window.fetch(url,config)
      }
    }
    /* shopify cart functions */
    siteUrl(path) {
      if (this.config.siteRoot) {
          return `${this.config.siteRoot}${path}`
      }
      return path
    }
    async getCart(url=this.siteUrl("/cart.js"),extended=false,callback=()=>{}) {
        let cart = {};
        return this.fetch(url)
      .then(res=>(extended)?res.text():res.json());
    }
    async updateCart(payload) {
      return this.fetch(this.siteUrl(`/cart/update.js`), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify(payload)
      }).then((response) => response.json());
   }
    async removeItemFromCart(key) {
        return this.updateItemCount(key,0);
        return this.changeCart({
            id:key,
            quantity:0
          })
    }
    async changeCart(payload) {
        return this.fetch(this.siteUrl(`/cart/change.js`), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(payload)
          }).then((response) => response.json());
     }
     async addToCart(payload) {
        let config = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        }
        return this.fetch(this.siteUrl("/cart/add.js"),config)
            .then((response) => response.json())
     }
      async addToDawnCart(form) {
  
         let cart = document.querySelector("cart-drawer");
         const formData = new FormData();
         formData.append('product-id',form.dataset.productId);
         formData.append("id",form.querySelector('[name="id"]').value)
         formData.append("quantity",1);
         try {
           formData.append("selling_plan",form.querySelector('[name="selling_plan"]').value);
         } catch(e) {}
  
         formData.append('sections',cart.getSectionsToRender().map((section) => section.id));
         formData.append('sections_url',form.dataset.url);
         formData.append('form_type','product');
  
         return this.fetch(this.siteUrl("/cart/add"),{
             method: 'POST',
             headers: {
                 "Accept":"application/javascript",
                 "X-Requested-With":"XMLHttpRequest"
             },
             body: formData,form
         })
             .then((response) => response.json())
             .then(json=>{
  
  
               if (json.status) {
                 YWMModal.show(json.description);
               } else {
                 cart.renderContents(json);
                 cart.classList.remove("is-empty")
               }
               return json;
         });
      }
  
     /* graphql functions */
     async graphql(query,params) {
        return fetch(this.siteUrl(`/api/${this.api_version}/graphql.json`),{
            method:"POST",
            headers:{
              "content-type":"application/json",
              "X-Shopify-Storefront-Access-Token":this.data.settings.apiKey
              },
              body:JSON.stringify({query:query,variables:params})
            })
            .then(response=>response.json())
    }
    graphql_sync(query,params) {
        let ajax = new XMLHttpRequest();
        ajax.headers = {
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
        }
        ajax.open("POST",this.siteUrl(`/api/${this.api_version}/graphql.json`),false)
        ajax.setRequestHeader("Content-Type", "application/json");
        ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", this.data.settings.apiKey);
        ajax.send(JSON.stringify({query:query,params:params}));
        return JSON.parse(ajax.responseText);
    }
    gid2id(gid) {
      return parseInt(gid.split("/").pop())
    }
    collapse_query(object) {
      if (object==null) {
          return object;
      }
      switch(object.constructor.name) {
      case "Array":
          return object.map(item=>item.constructor.name=="String"?item:this.collapse_query(item));
          break;
        case "Object":
            let ret = {};
            Object.keys(object).forEach(key=>{
                if (object[key]==null) {
                    ret[key] = null;
                    return;
                }
                /* mwetaobject field */
                if (object[key].type!=null) {
                  switch(object[key].type) {
                    case "boolean":
                      if (object[key].value==null) {
                        ret[key] = false;
                        return;
                      } else {
                        ret[key] = this.collapse_query(object[key].value);    
                      }
                      
                    break;
                    default:
                      ret[key] = this.collapse_query(object[key].value);
                  }
                }
                if (object[key].reference) {
                    ret[key] = this.collapse_query(object[key].reference)
                    return;

                }
                if (object[key].references) {
                    let all = [];
                    object[key].references.nodes.forEach(ref=>{
                        let crv = {};
                        if (ref.fields) {
                          ref.fields.forEach(field=>{
                            crv[field.key]=this.collapse_query(field.value)
                          })  
                        } else {
                          Object.keys(ref).forEach(field=>{
                            if (object[field]?.type!=null) {
                              switch(object[field].type) {
                                case "boolean":
                                  if (object[field].value==null) {
                                    crv[field] = false;
                                    
                                  } else {
                                    crv[field] = this.collapse_query(object[key].value);    
                                  }
                                break;
                                default:
                                  crv[key] = this.collapse_query(object[key].value);
                                  
                              }
                            } else if (ref[field]?.constructor.name=="String") {
                              crv[field] = ref[field];
                            } else if (ref[field]?.constructor.name=="Array") {
                              crv[field]=this.collapse_query(ref[field])
                            
                            } else {
                              if (ref[field]) {
                                if (ref[field].value) {
                                  crv[field]=this.collapse_query(ref[field].value)    
                                } else {
                                  let newHash = {}
                                  Object.keys(ref[field]).forEach(key=>{
                                    newHash[key] = this.collapse_query(ref[field][key])
                                  });
                                  crv[field] = newHash
                                }
                                
                                
                              } else {
                                crv[field] = null
                              }
                            }
                          })
                        }
                        
                        all.push(crv)
                    })
                    object[key] = all;

                }
                if (object[key].type && object[key].type=="json") {
                  object[key] = JSON.parse(object[key ])
                }
                if (object[key].nodes && object[key].nodes.constructor.name=="Array") {
                    ret[key] = this.collapse_query(object[key].nodes);
                } else {
                    ret[key] = this.collapse_query(object[key])
                }
            });
            return ret
            break;
          default:
              if (object) {
                if (object=="true") {
                  return true;
                } else if (object=="false") {
                  return false;
                }
                return object;
              }
  
              break;
      }
    }
    slugify(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
        str = str.toLowerCase(); // convert string to lowercase
        str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
                .replace(/\s+/g, '-') // replace spaces with hyphens
                .replace(/-+/g, '-'); // remove consecutive hyphens
        return str;
    }
  getCookie(cookieName) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [name, value] = cookie.split('=');
      if (name == cookieName) {
          return decodeURIComponent(value);
      }
    }
    return null;
  }
  setCookie(name,value,expires=null) {
    let cookie = `${name}=${value};path=/`
    if (expires==null) {
      let d = new Date();
      d.setTime(d.getTime()+(10*365*248624*60*60*1000));
      expires = this.deltaDate(10,0,0,0,0,0)
    }
    document.cookie = `${name}=${value};path=/;expires=${expires}`
  }
  deltaDate(years,months,weeks,days,hours,minutes) {
    let time = minutes*60*1000;
    [hours,days,months,years].forEach(period=>{
      if (period!=null && period>0) {
        time = time*period;
      }
    })
    console.error(time,years,months,weeks,days,hours,minutes)
    let d = new Date()
    d.setTime(d.getTime()+time);
    return d.toUTCString()
  }
  setCookieForYears(name,value,count) {
    this.setCookie(
      name,value,
      this.deltaDate(count,0,0,0,0,0)
    )
  }
  setCookieForMonths(name,value,count) {
    this.setCookie(
      name,value,
      this.deltaDate(0,months,0,0,0,0)
    )
  }
  setCookieForWeeks(name,value,count) {
    this.setCookie(
      name,value,
      this.deltaDate(0,0,count,0,0,0)
    )
  }
  setCookieForDays(name,value,count) {
    this.setCookie(
      name,value,
      this.deltaDate(0,0,0,count,0,0)
    )
  }
  setCookieForHours(name,value,count) {
    this.setCookie(
      name,value,
      this.deltaDate(0,0,0,0,count,0)
    )
  }
  setCookieForMinutes(name,value,count) {
    this.setCookie(
      name,value,
      this.deltaDate(0,0,0,0,0,count)
    )
  }
  deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  }
  setHiddenFieldValue(form,property,value) {
      let field = form.querySelector(`[name="properties[${property}]"]`)
      if (field==null) {
          field = document.createElement("INPUT");
          field.name = `properties[${property}]`;
          field.type="hidden";
          form.appendChild(field)
      }
      
      field.value = value;
  }
  unsetHiddenFormValue(form,property) {
    let field = form.querySelector(`[name="properties[${property}]"]`);
    if (field!=null) {
      field.parentNode.removeChild(field);
    }
  } 

}
class Sorcistino extends YWM {
    defaults() {
        return {
            root:".sorcistino-holder",
            zeroButtonBehavior: "hide",
            class:"sorcistino",
        }
    }
    DOMTarget() {
      return document.querySelector(this.config.root);
    }
    constructor(options) {
        super(options)
        this.screens = [];
        this.screen = 0;
        this.data = {
          settings:this.loadJSON("settings")
        };
        this.screenData = {}
        this.uuid = crypto.randomUUID();
        this.setupOnetimeEvents();
        this.loadConfiguration().then(result=>{
            //this.data = {...this.data,...result};
            this.init(result);
            if (this.screens.length) {
              this.show(0)
            }
        })
    }
    async loadConfiguration() {
        return new Promise((resolve,reject)=>{
            return resolve({})
        });
    }
    EventTarget() {
        return this.DOMTarget().querySelector(".sorcistino-hut");
    }
    processScreen(data) {

    }
    query() {
        return ``;
    }
    addScreen(data,index) {
        this.screens.push(new SorcistinoScreen(this,data,index))
    }
    textFor(key,defaultText=null) {
      try {
        let text =  this.data.text[key];
        if (text==null) {
          if (defaultText==null) {
            return `no text found for ${key}`;  
          }
          return defaultText;
          
        }
        return text;
      } catch (e) {
        return `no text found for ${key}`;
      }
    }
    render(startingScreen=0) {
        this.DOMTarget().innerHTML = `
            <div class="sorcistino-hut ${this.roorClasses()} ${this.isMobile()?'mobile':''} ${this.canGoForward()?'nav-next':''} ${this.canGoBack()?'nav-previous':''}">
                <div class="sorcistino-header">
                    <div class="title">${this.currentScreen().title()}</div>
                    ${this.renderHeader()}
                </div>
                <div class="sorcistino-error">${this.currentScreen().errors()}</div>
                <div class="content" id="screen-${this.currentScreen().handle()}">
                  <style type="text/css">
                    #screen-${this.currentScreen().handle()} {
                      ${this.currentScreen().data.customCss||''}
                    }
                  </style>
                  ${this.currentScreen().content()}
                </div>
                <div class="footer">
                    ${this.renderFooter()}
                </div>
                <div class="postamble">${this.currentScreen().postamble()}</div>
            </div>
        `;
        this.DOMTarget().querySelector(".progress-bar").style.width=`${this.progress()}%`;
        this.setupEvents();
    }
    renderProgress() {
      return `
      <div class="progress">
        <div class="progress-bar-wrapper js-progress-bar-wrapper">
          <div class="progress-bar" style="width: 0%;"></div>
        </div>
      </div>
      `
    }
    roorClasses() {
      return '';
    }
    navButtonPlacement() {
      return "bottom";
    }
    renderInterstitial() {

      return `${this.currentScreen().interstitial()}`;
    }
    renderQuickNav() {
      let completedScreens = this.screens.filter(screen=>screen.isComplete==true);
      if (completedScreens.length<1) {
        return '';
      }
      
      return `
        <div id="quickNav">
          <select class="quick-nav" name="quickNav">
            <option id="choose">${this.textFor("quicknav_goto","Jump to")}</option>
            ${completedScreens.map((screen,index)=>`<option value="${index}" ${this.screen==index?'selected':''}>${screen.title()}</option>`).join("")}
          </select>
        </div>
      `

    }
    renderNavButtons() {
      return `
      <div class="interstitial">${this.renderInterstitial()}</div>
      <div class="nav">
            <ul class="sorcistino-nav-menu">
                <div class="sorcistino-nav-holder">
                    <div class><button class="sorcistino-nav-button" data-screen="${this.currentScreen().screenId()}" data-nav="previous" aria-label="Previous">${this.textFor("prev_button_label","Back")}</button></div>
                    <div class="screenNavContent">${this.currentScreen().navContent()}</div>
                    <div><button class="sorcistino-nav-button" data-screen="${this.currentScreen().screenId()}" data-nav="next" aria-label="Next">${this.textFor("next_button_label","Next")}</button></div>
                </div>
            </ul>
        </div>
        `
    }
    renderHeader() {
      return `
        ${this.renderProgress()}
        ${["top","both"].includes(this.navButtonPlacement())?this.renderNavButtons():''}
      `
    }
    renderFooter() {
        return `${["bottom","both"].includes(this.navButtonPlacement())?this.renderNavButtons():''}`
    }
    setupOnetimeEvents() {

    }
    setupEvents() {
        this.DOMTarget().querySelectorAll(".sorcistino-nav-button").forEach(
          button=>button.addEventListener("click",event=>{
            this.navigate(button);
            
          })
        )
        this.DOMTarget().querySelectorAll(".quick-nav").forEach(nav=>{
          nav.addEventListener("focus",event=>nav.size=this.screens.filter(screen=>screen.isComplete).length);
          nav.addEventListener("blur",event=>nav.size=0);
          nav.addEventListener("click",event=>{
            let value=nav.options[nav.selectedIndex].value;
            if (value!=null) {
              this.show(parseInt(value));
            }
          })

        })
        
    }
    getScreen(index) {
      if (index>=0) {
        return this.screens[index]
      }
    }
    navigate(navButton,navType) {
      if (navButton!=null) {
        navType = navButton.dataset.nav;
      }
      if (navType=="previous") {
        let screenIndex = this.screen-1;
        if (screenIndex<0) {
          return;
        }
        while (screenIndex>=0) {
          let screen = this.screens[screenIndex]
          if (screen.isConditionalScreen() && !screen.meetsConditions()) {
            screenIndex = screenIndex - 1;
          } else {
            break;
          }
          
        }
        this.show(screenIndex);
      } else if (navType=="next") {
        let screenIndex = this.screen;
        if (screenIndex+1>=this.screens.length) {
          return;
        }
        if (this.nextBehaviour()=="nextCompletes") {
          if (this.screens[this.screen].isCompleted()) {
            screenIndex = screenIndex+1;
          } else {
            this.screens[this.screen].complete();
            return;
          }
        } else if (this.nextBehaviour()=="afterComplete" && this.screens[this.screen].completed()) {
          screenIndex = screenIndex + 1;
        }
        while(screenIndex<this.screens.length) {
          let screen = this.screens[screenIndex];
          if (screen.isConditionalScreen() && !screen.meetsConditions()) {
            screenIndex = screenIndex+1
          } else {
            break;
          }
        }
        this.show(screenIndex);
      }
    }
    next() {
      this.navigate(null,"next");
    }
    prev() {
      this.navigate(null,"previous");
    }
    progress() {
      if (this.screens.length<=1) {
        return 100;
      }
      return Math.floor((this.screen/(this.screens.length-1))*100);
    }
    currentScreen() {
        return this.screens[this.screen];
    }
    renderScreen() {
        this.currentScreen().render()
    }
    setScreen(index) {
        this.screen = index;
        return this.currentScreen()
    }
    canGoBack() {
      return this.screen-1>=0;
    }
    canGoForward() {
      return (this.currentScreen().isCompleted() && !this.currentScreen().isFinalScreen()) || this.currentScreen().canComplete();
    }
    nextBehaviour() {
      return "afterComplete"
    }
    invalidatePast(index) {
      for (let i=index+1;index<this.screens.length;i++) {
        this.screens[index].uncomplete()
      }
    }
    show(screen) {
        this.screen = screen;
        let screenObj = this.setScreen(screen)
        screenObj.render();
        window.scrollTo({behavior:"smooth",top:0,left:0})
    }
    init(data) {

    }
    finalize() {

    }
    isMobile() {
      return window.innerWidth<=762;
    }
    setNext(can=true) {
      if (can) {
        this.EventTarget().classList.add("nav-next")
      } else {
        this.EventTarget().classList.remove("nav-next")
      }
    }
    setPrevious(can=true) {
      if (can) {
        this.EventTarget().classList.add("nav-previous")
      } else {
        this.EventTarget().classList.remove("nav-previous")
      }
    }
}
class SorcistinoQuiz extends Sorcistino {
    async loadConfiguration() {
        
        return this.graphql(
            `query getQuiz($handle:MetaobjectHandleInput) {
                quiz: metaobject(handle:$handle) {
                    handle
                    title: field(key:"title") {
                        value
                    }
                    minimumScore: field(key:"minimum_qualifying_score") {
                      value
                    }
                    productSet: field(key:"product_set") {
                      references(first:50) {
                        nodes {
                          ... on Product {
                            id
                            title
                            handle
                            productType
                            tags
                            options(first:10) {
                              name
                            }
                            image: featuredImage {
                                alt: altText
                                url
                            }
                            size: metafield(namespace:"custom",key:"holster_size") {
                                value
                            }
                            reviewsCount: metafield(namespace:"custom",key:"reviews_count") {
                                value
                            }
                            rating: metafield(namespace:"custom",key:"reviews_average") {
                                value
                            }
                            ${this.additionalProductFields()}
                            variants(first:10) {
                                nodes {
                                    id
                                    available: availableForSale
                                    title
                                    price {
                                        amount
                                    }
                                    selectedOptions {
                                        name
                                        value
                                    }
                                    image {
                                        url
                                    }
                                    ${this.additionalVariantFields()}
                                }
                            }
                          }
                        }
                      }
                    }
                    text: field(key:"text") {
                      references(first:50) {
                          nodes {
                              ... on Metaobject {
                                  text: field(key:"text") {
                                      value
                                  }
                                  id: field(key:"identifier") {
                                      value
                                  }
                              }
                          }
                      }
                    }
                    questions: field(key:"questions") {
                        references(first:20) {
                            nodes {
                                ... on Metaobject {
                                    handle
                                    autoAdvance: field(key:"radio_select_autoadvance") {
                                      type
                                      value
                                    }
                                    weight: field(key:"fieldweight") {
                                      value
                                    }
                                    title: field(key:"title") {
                                        value
                                    }
                                    questionType: field(key:"question_type") {
                                        value
                                    }
                                    requiresSelection: field(key:"requires_selections") {
                                        type
                                        value
                                    }
                                    className: field(key:"className") {
                                        value
                                    }
                                    dataPoint: field(key:"data_point") {
                                        value
                                    }
                                    dataPointField: field(key:"data_point_field") {
                                      value
                                    }
                                    fieldName: field(key:"optionName") {
                                        value
                                    }
                                    reviewLabel: field(key:"reviewlabel") {
                                      value
                                    }
                                    image: field(key:"image") {
                                        reference {
                                            ... on MediaImage {
                                                image {
                                                    alt: altText
                                                    url
                                                }
                                            }
                                        }
                                    }
                                    imagePlacement: field(key:"image_placement") {
                                      value
                                    }
                                    imageCss: field(key:"image_css") {
                                      value
                                    }
                                    customCss: field(key:"custom_css") {
                                      value
                                    }
                                    options: field(key:"options") {
                                        references(first:20) {
                                            nodes {
                                                ... on Metaobject {
                                                    handle
                                                    label: field(key:"label") {
                                                        value
                                                    }
                                                    isDefault: field(key:"default_option") {
                                                      type
                                                      value
                                                    }
                                                    mutuallyExclusive: field(key:"mutually_exclusive_with") {
                                                      references (first:20) {
                                                        nodes {
                                                          ... on Metaobject {
                                                            handle
                                                            label:field(key:"label") {
                                                              value
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                    weight: field(key:"option_weight") {
                                                      value
                                                    }
                                                    answer: field(key:"value") {
                                                        value
                                                    }
                                                    description: field(key:"description") {
                                                        value
                                                    }
                                                    icon: field(key:"icon") {
                                                        reference {
                                                            ... on MediaImage {
                                                                image {
                                                                    alt: altText
                                                                    url
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            `,
            {
              "handle":{
                "handle":this.data.settings.metaobject_id,
                "type":"quiz"
              }
            }
        )
        /* "id":`gid://shopify/Metaobject/${this.metaobjectId()}` */
    }
    additionalProductFields() { return ''};
    additionalVariantFields() { return ''};
    classMap(className) {
        return SorcistinoSelectionScreen;
    }
    metaobjectId() {
      return "8675309";
    }
    init(data) {
        
        
        this.data = {...this.data,...this.collapse_query(data).data.quiz}

        

        //this.data = this.collapse_query(data).data.quiz;
        let snippets = {};
        this.data.text.forEach(snippet=>{
          snippets[snippet.id] = snippet.text;
        });
        this.data.text = snippets;
        this.data.handleCriterionMap = {};
        this.data.handleLabelMap = {}
        
        this.data.productSet?.forEach(product=>{
          product.options = product.options.map(option=>option.name);
          product.image = product.image.url;
          product.alt = product.image.alt||product.title;
          product.id=this.gid2id(product.id);
          product.matchScore=0;
          product.variants = product.variants.map(variant=>{
            variant.price = variant.price.amount;
            variant.id  = this.gid2id(variant.id);
            variant.options = variant.selectedOptions.reduce((a,b)=>{
              let newEntry = {};
              newEntry[b.name]=b.value;
              return {...a,...newEntry};
            },{});
            variant.selectedOptions = variant.selectedOptions.map(option=>option.value);
            
            return variant;
          })
        })
        this.data.questions.forEach((screen,index)=>{
            if (["Multiple Choice","Single Choice"].includes(screen.questionType) && (!screen.options || screen.options.length<1)) {
                return;
            }
            /* take out later!!!! */
            let instanceClass = this.classMap(screen.className);
            
            if (instanceClass!= null) {
                if (screen.options) {
                  screen.options.forEach(option=>{
                    this.data.handleCriterionMap[option.handle] = option.answer;
                    this.data.handleLabelMap[option.handle] = option.label;
                  });
                }
                let instance = new instanceClass();
                instance.set({
                    uuid:crypto.randomUUID(),
                    index:this.screens.length,
                    screenCount:this.data.questions.length,
                    parent:this,
                    data:screen,
                });
                this.screens.push(instance);
            }
        });
        this.log(this);
    }
    nextBehaviour() {
        return "nextCompletes";
    }
}

class SorcistinoScreen {
    constructor(parent,data,index,screenCount) {
        this.screenCount = screenCount;
        this.index = index;
        this.parent = parent;
        this.data = data;
        this.isComplete = false;
        this.uuid = crypto.randomUUID()
        if (this.data) {
          this.constructed();
        }
    }
    textFor(identifier,defaultText=null) {
      return this.parent.textFor(identifier,defaultText);
    }
    screenId() {
      if (this.index+1==this.parent.screens.length-1) {
        return "submit-final";
      }
      return this.index+1;
    }
    handle() {
      return `screen-${this.index}`
    }
    errors() {
      if (this.data.error) {
        return this.data.error;
      }
      return '';
    }
    skippable() { return false;}
    postamble() { return '';}
    interstitial() { return '';}
    navContent() {
      return '';
    }
    DOMTarget() {
      return this.parent.DOMTarget();
    }
    constructed() {

    }
    canComplete() {
      return false
    }
    set(object) {
      Object.keys(object).forEach(key=>this[key] = object[key])
      this.constructed()
    }
    isConditionalScreen() {
        return false;
    }
    meetsConditions() {
        return true;
    }
    setupEvents() {
    }
    hideBack() {
      return false;
    }
    isCompleted() {
        return this.isComplete;
    }
    complete() {
    
    }
    unComplete() {
      this.isCompleted = false;
    }
    broadcastCompletion(data={}) {
      this.is_completed=true;
      YWM.dispatchEvent(
        "sorcistino:screen:completed",
        data
      )
      return this.is_completed;
    }
    data() {
        return this.data;
    }
    is_final() {
      return this.screen.hasAttribute("data-final-screen");
    }
    render() {
        this.parent.render();
        this.setupEvents()
        //window.scrollTo({behavior:"smooth",top:0,left:0})
    }
    contentWrapper(content) {
      return `${content}`
    }
    content() {
      return this.contentWrapper(`content`);
    }
    preserve() { return false;}
    title() {
      return 'title'
    }
    root() {
      return document.querySelector(`[data-uuid="${this.uuid}"]`)
    }
    element(selector) {
      return this.root().querySelector(selector)
    }
    isMobile() {
      return window.innerWidth<=762;
    }
    isFinalScreen() {
      return this.index+1==this.screenCount;
    }
    setScreenData(value,weight=0) {
      this.parent.screenData[this.data.fieldName] = {
        screen:this.index,
        datapoint:this.data.dataPoint,
        reviewLabel:this.data.reviewLabel,
        fieldWeight: parseFloat(this.data.weight||"0")+weight,
        value:value||[]
      }
      
    }
    getScreenData() {
      if (this.parent.screenData[this.data.fieldName]) {
        return Array.from(new Set(this.parent.screenData[this.data.fieldName].value));
      }
      return []
    }
    getConditionalCriteria(fieldName) {
      let rawValue = this.parent.screenData[fieldName];
      
      return rawValue.value.map(criterion=>this.parent.data.handleCriterionMap[criterion]);
    }
    getConditionalCriterion(fieldName) {
      let rawValue = this.parent.screenData[fieldName];
      return rawValue.value.map(criterion=>this.parent.data.handleCriterionMap[criterion])[0];
    }

    getScalarScreenData() {
      if (this.parent.screenData[this.data.fieldName]) {
        return this.parent.screenData[this.data.fieldName].value[0]
      }
      return null;
    }
    setArbitraryScreenData(key,value) {
      this.parent.screenData[key] = value;
    }
    getArbitraryScreenData(key) {
      return this.parent.screenData[key];
    }
    screenDataValues() {
      let values = Object.values(this.parent.screenData).reduce(
        (a,b)=>a.concat(b.constructor.name=="Object"?b.value:[]),
        []
      )
      return values;
    }
    setupEvents() {
      this.DOMTarget().querySelectorAll("a[data-screen]").forEach(screenLink=>screenLink.addEventListener(
            "click",
            event=>{
                event.preventDefault();
                event.stopPropagation();
                this.parent.show(parseInt(event.target.dataset.screen));
            })
        );
    }
}

class SorcistinoQuizScreen extends SorcistinoScreen {

  
}

class SorcistinoSelectionScreen extends SorcistinoQuizScreen {
    handle() {
      return this.data.handle
    }
    constructed() {
        super.constructed();
        this.data.value = [];
        this.mutualExlcusions = this.data.options.filter(option=>option.mutuallyExclusive!=null).reduce(
          (a,b)=>a.concat(b),
          []
        ).map(option=>option.handle);
        let defaultOption = this.data.options.find(option=>option.isDefault);
        if (defaultOption) {
          this.data.value = [defaultOption.handle]
        }
    }
    type() {
        return this.data.questionType=="Multiple Choice"?"checkbox":"radio";
    }
    isSelected(value) {
      if (this.data.value.length<1) {
        if (this.data.options.find(option=>option.handle==value)?.isDefault) {
          return true;
        }
      }
      return this.data.value.includes(value);
    }
    isConditionalScreen() { return true;}
    meetsConditions() {
      let excludedCount = 0;
      this.data.options.forEach(option=>{
        if (this.isMutuallyExcluded(option)) {
          excludedCount++;
        }
      })
      if  (excludedCount>=this.data.options.length) {
        this.setScreenData([])
        return false;
      }
      return true;
    }
    screenDataFor(value) {
        let match = this.parent.screens.filter(screen=>screen.data.options).reduce(
          (a,screen)=>a.concat(
            screen.data.options.map(option=>option.handle).includes(value)?screen:[]
          ),
          []
        ).find(x=>x!=null);
        
      if (match!=null) {
        return match.data;
      }
    }
    mutuallyExcluded(option) {
      let selectedOptions = this.screenDataValues().concat(this.data.value);
      return option.mutuallyExclusive?.filter(selected=>selectedOptions.includes(selected.handle));
    }
    isMutuallyExcluded(option) {
      return this.mutuallyExcluded(option)?.length>0;
    }
    renderExclusions(option) {
      if (!this.showIncompatibilityLabel) {
        return '';
      }
      if (option.mutuallyExclusive) {
        let exclusions = this.mutuallyExcluded(option);
        if (exclusions==null) {
          return '';
        }
        let excludedEntries = exclusions.map(
          exclusion=>this.data.options.find(option=>option.handle==exclusion.handle)?exclusion.label:`
            ${exclusion.label} (<a href="#" data-screen="${this.screenDataFor(exclusion.handle)?.index}">change</a>)
          `
          );
        let excludedText = '';
        if (excludedEntries.length>1) {
          let lastEntry = excludedEntries.pop();
          excludedText = [excludedEntries.join(","),lastEntry].join(" and ");
        } else {
          excludedText = excludedEntries.join(",");
        }
        return `<div class="incompatibles">Incompatible with: ${excludedText} </div>`;
      }
      return '';
    }
    content() {
         let imageHtml = this.placeImageAt("Top")
         let options = `
            ${imageHtml!=null?imageHtml:''}
            ${this.data.options.map((option,index)=>`
                <div class="option-row">
                    <label for="${this.data.fieldName}-${index}-${option.answer}">
                        <input type="${this.type()}" name="${this.data.fieldName}" id="${this.data.fieldName}-${index}-${option.answer}" data-value="${option.handle}" data-criterion="${option.answer}" value="${index}-${option.answer}" data-weight="${option.weight?option.weight:'0'}" ${this.isSelected(option.handle)?'checked':''} data-handle="${option.handle}" ${this.isMutuallyExcluded(option)?'disabled':''} data-collect>
                        <div class="optionIcon">${option.icon==null?'':`<img src="${option.icon.image.url}">`}</div>
                        <div class="option-text">
                          <span class="main">${option.label}</span>
                          ${this.renderExclusions(option)}
                        </div>

                    </label>
                </div>
            `).join("")}
            <div class="clear-options">Clear Options</div>
        `
        let imageLeft = this.placeImageAt("Left");
        let imageRight = this.placeImageAt("Right");
        if (imageLeft) {
          return `
            <div class="quiz-options-two-col">
              ${imageLeft}
              <div class="options">
                ${options}
              </div>
            </div>
          `
        } else if (imageRight) {
          return `
            <div class="quiz-options-two-col">
              <div class="options">
                ${options}
              </div>
              ${imageRight}
            </div>
          `
        } else {
          return options;
        }
    }
    setValue(values,weight) {
        this.data.optionsWeight=weight;
        this.isComplete = false;
        if (values.length>0) {
            this.data.value = values;
            this.parent.setNext(true);
        } else {
            this.data.value = values;
            if (this.data.requiresSelection) {
                this.parent.setNext(false);
            }
        }
        this.setScreenData(this.data.value,this.data.optionsWeight);
    }
    setupEvents() {
      super.setupEvents();
      
        this.DOMTarget().querySelectorAll('input[data-collect]').forEach(
            box=>box.addEventListener(
                "change",
                event=>{
                  this.isComplete = false;
                  this.setValue(
                    Array.from(this.DOMTarget().querySelectorAll('input:checked')).map(entry=>entry.dataset.value),
                    Array.from(this.DOMTarget().querySelectorAll('input:checked')).reduce((a,b)=>a+parseFloat(b.dataset.weight),0)
                  );
                  if (this.data.questionType=="Single Choice") {
                    if (this.data.autoAdvance) {
                      this.parent.next();
                    } else {
                      this.render();
                    }
                  } else {
                    this.render();
                  }
                  
                }
            )
        );
    }
    canComplete() {
        if (this.data.questionType=="Multiple Choice" && !this.data.requiresSelection) {
            return true;
        }
        if (this.data.value.length<1) {
            return false;
        }
        return true;
    }
    complete() {
        if (this.data.value.length<1 && this.data.requiresSelection) {
            return;
        }
        this.isComplete = true;
        this.setScreenData(this.data.value,this.data.optionsWeight);
        this.parent.next()
    }
    placeImageAt(position) {
      
      if (this.data.image && this.data.imagePlacement==position) {
        if (this.data.image) {
            return `
                <div class="screen-image" id="screen-image-${this.handle()}">
                    <img src="${this.data.image.image.url}" alt="${this.data.image.alt||''}">
                </div>
                <style type="text/css">
                  #screen-image-${this.handle()} {
                    ${this.data.imageCss?this.data.imageCss:''}
                  }
                </style>
            `
        }
      }
      return null;
    }
    navContent() {
        
        let imageNav = this.placeImageAt("Navigation");
        if (imageNav) {
          return imageNav;
        }
        return ``;
    }
    interstitial() {
      let imageNav = this.placeImageAt("Bottom");
      if (imageNav) {
          return imageNav;
        }
        return ``
    }
}

class FinalScreenData {
  constructor(sorcistinoInstance) {
    this.sorcistino = sorcistinoInstance;
  }
  get(fieldName) {
      if (this.sorcistino.screenData[fieldName]) {
        return Array.from(new Set(this.sorcistino.screenData[fieldName].value));
      }
      return []
    }
    getScalar(fieldName,index=0) {
      if (this.sorcistino.screenData[fieldName]) {
        return this.sorcistino.screenData[fieldName].value[index]
      }
      return null;
    }
    getArbitrary(fieldName) {
      if (this.sorcistino.screenData[fieldName]) {
        return this.sorcistino.screenData[fieldName];
      }
      return null;
    }
    getCriteria(fieldName) {
      return this.get(fieldName).map(handle=>this.sorcistino.data.handleCriterionMap[handle]);
    }
    getCriterion(fieldName,index=0) {
      return this.getCriteria(fieldName)[index];
    }
    getLabel(fieldName,index=0) {
      return this.getLabels(fieldName)[index];
    }
    getLabels(fieldName) {
      return this.get(fieldName).map(handle=>this.sorcistino.data.handleLabelMap[handle]||handle);
    }
    getReviewLabel(fieldName) {
      if (this.sorcistino.screenData[fieldName]) {
        return this.sorcistino.screenData[fieldName].reviewLabel;
      }
      return "";
    }
    getFieldWeight(fieldName) {
      if (this.sorcistino.screenData[fieldName]) {
        return this.sorcistino.screenData[fieldName].fieldWeight;
      }
    }
    raw(fieldName) {
      return this.sorcistino.screenData[fieldName]
    }
    getDataPoint(fieldname) { 
      let object = this.sorcistino.screenData[fieldName];
      if (object && object.constructor.name=="Object") {
        return object.datapoint;
      }
      return null;
    }
    getScreen(fieldName) {
      let object = this.sorcistino.screenData[fieldName];
      if (object && object.constructor.name=="Object") {
        return object.screen;
      }
      return null;
    }
    getReviewEntry(fieldName,index=0) {
      let screenData = this.sorcistino.screenData[fieldName];
      if (screenData) {
        return {
          label:this.getReviewLabel(fieldName),
          value: [this.getLabel(fieldName,index)],
          screen:screenData.screen,
        }
      }
      return null;
    }
    optionsFor(fieldName) {
      let screen = this.sorcistino.screens.find(screen=>screen.data.fieldName==fieldName);
      if (!screen) {
        return []
      }
      return screen.data.options.map(option=>option.answer);
    }
}

/* custom */


class NighstickHeaderSelector extends YWM {
  constructor(options={}) {
    super(options);

    this.selectedMake = this.getCookie("nightstick_make");
    this.selectedModel = this.getCookie("nightstick_model");
    this.goButton = document.querySelector(".header-selector-go-wrapper");

    this.weaponHandle = location.pathname.split("/").pop()

    this.openPopupButton = document.querySelector(".classic-button2");
    this.popupOverlay = document.querySelector(".popup-overlay");
    this.popupContent = document.querySelector(".popup-content");

    this. popupOverlay.addEventListener("click", event=>{
      if (event.target === this.popupOverlay) {
        this.popupOverlay.style.display = "none";
      }
    });
    if (this.openPopupButton) {
      this.openPopupButton.addEventListener("click",event=>{
        this.showPopup()
      })
    }

    
    this.makesDisplayNum = parseInt(this.config.displayMakes);  
    this.manufacturerSelectElement = document.getElementById(`select-manufacturer`);
    this.modelSelectElement = document.getElementById(`select-model`);
    if (window.firearmsDB) {
      this.init();
    } else {
      document.addEventListener("ywm:database:loaded",event=>{
        this.init()
      });
    }
    document.addEventListener("ywm:autoselect:success",event=>{
      this.selectedMake = event.detail.manufacturer;
      this.selectedModel = event.detail.name;
        setTimeout(() => {
          console.error()
          try {
          this.manufacturerSelectElement.options.find(option=>option.value==this.selectedMake).selected=true;
          this.modelSelectElement.options.find(option=>option.value==this.selectedModel).selected=true;
        } catch(e) {
          console.error(e)
        }  
        }, 400);
    })
  }
  init() {
    let selectedFirearm=null;
    let weaponId=null;
    if (this.weaponHandle) {
      try {
        selectedFirearm = window.firearmsDB.flat().find(model=>model.collection==this.weaponHandle)
      } catch(e) {
        console.error(e)
      }
      
    }
    
    
   
    if (selectedFirearm) {
      this.selectedFirearm = selectedFirearm
      this.selectedMake = selectedFirearm.manufacturer
      this.selectedModel = selectedFirearm.name
    } else if (this.selectedMake && this.selectedModel) {
        this.selectedFirearm = window.firearmsDB.firearmByMakeModel(this.selectedMake,this.selectedModel)
    }
    if (this.selectedFirearm) {
      this.populateGridInserts();
      this.populateModels(this.selectedMake)
    }

    this.manufacturerSelectElement.innerHTML = `
      <option value="" selected>Select Manufacturer...</option>
      ${window.firearmsDB.allManufacturers().map(make=>`<option value="${make}" ${make==this.selectedMake?'selected':''}>${make}</option>`).join("\n")}
        
    `;
    this.manufacturerSelectElement.addEventListener("change",event=>{
        this.selectedMake = event.target.options[event.target.selectedIndex].value;

        if (this.selectedMake=='') {
          this.modelSelectElement.innerHTML = `<option value="">Select Model...</option>`
          return;
        } 
        this.populateModels(this.selectedMake);
        document.querySelector("#model-results").textContent = `${window.firearmsDB.models(this.selectedMake).length} models available for ${this.selectedMake}`
    });
    this.modelSelectElement.addEventListener("change",event=>{
      this.selectedMake = this.manufacturerSelectElement.options[this.manufacturerSelectElement.selectedIndex].value;

      let selectedModel = event.target.options[event.target.selectedIndex];
      if (selectedModel.value=='') {
        return;
      }
      this.selectedModel = selectedModel.value;
      console.error(this.selectedMake,this.selectedModel)
      this.setCookieForSelected()
      

      location.href = `${selectedModel.dataset.handle}`;
    })
    this.goButton?.addEventListener(
      "click",
      event=>{
        let selectedModel = this.modelSelectElement.options[this.modelSelectElement.selectedIndex];
        location.href = `/pages/${selectedModel.dataset.type}/${selectedModel.dataset.handle}`;
      }
    )
    if (this.selectedMake) {
      this.populateModels(this.selectedMake);
      this.goButton?.classList.add("active");
      
    }
  }
  mapModels(models) {
    return JSON.parse(JSON.stringify(models)).sort((a,b)=>a.name.localeCompare(b.name)).map(model=>`<option value='${model.name}'
       data-handle="/collections/${model.collection}" 
       data-type="${this.config.metaobjectPage}" ${model.name==this.selectedModel?'selected':''}>${model.name}</option>`).join("\n")
  }
  setCookieForSelected() {
    this.setCookieForMinutes("nightstick_make",this.selectedMake||this.selectedFirearm.manufacturer,15)
    this.setCookieForMinutes("nightstick_model",this.selectedModel||this.selectedFirearm.name,15)
  }
  populateGridInserts() {
    if (this.selectedFirearm) {
      document.querySelectorAll("[data-insert-for-sku]").forEach(insertNode=>{
        let sku = insertNode.dataset.insertForSku;
        let insert = this.selectedFirearm.inserts.find(entry=>entry.sku==sku);
        if (insert!=null) {
          insertNode.textContent = `Requires ${insert.insert} insert`;
        }
      })
    }
  }
  populateModels(selectedMake) {
    let allModels = window.firearmsDB.modelsWithProducts(selectedMake);

    let popular = allModels.filter(model=>model.featured)
    let standard = allModels.filter(model=>!model.featured)
    let options  = ``
    if (popular.length) {
      options = `
        ${this.mapModels(popular)}
        <option value="" disabled>----</option>
        <option value="" disabled>-ALL MODELS-</option>
        ${this.mapModels(standard)}
    `
    } else {
      options = `${this.mapModels(standard)}`
    }

    
      this.modelSelectElement.innerHTML = `
        <option value="">Select Model...</option>
        ${options}
      `;
  }
  showPopup() {
    let innerHTML = `
      <div id="CollectionSection-template--20626935480489__ywm_handgun_insert_BaGWNx" data-section-id="template--20626935480489__ywm_handgun_insert_BaGWNx" data-section-type="collection-compare">   
        <div class="page-width">
          <div class="section-header section-header--with-link">  
            <h2 class="section-header__title">Handgun Inserts for ${this.selectedFirearm.fullName}</h2>
            <a href="/collections/weapon-lights" class="btn btn--secondary btn--small section-header__link">View All Weapon Lights</a>
          </div>
          <div class="grid grid--uniform  section-header--with-link">
            <p></p><p>
            </p>
          </div>
      </div>
      <div class="page-width">
        <p></p>
        <div>
          <div class="grid grid--uniform">
            <ul class="rt-table cols-12">
          	  <li class="rt-head">
          		  <ul>
          			  <li class="col-4"><span class="col-heading">PRODUCT</span></li>
                  <li class="col-2"><span class="col-heading">INSERT FOR ${this.selectedFirearm.fullName}</span></li>       
          		  </ul>
          	  </li>
            ${this.selectedFirearm.inserts.map(insert=>`
              <li class="rt-row">  
                <dl class="col-4">
                    <dt>Product</dt>
                    <dd><a href="/products/${insert.handle}" title="${insert.title}">${insert.sku}</a></dd>
              </dl>
              <dl class="col-2">
                  <dt>Insert</dt>
                  <dd class="ll">
                    ${insert.insert}<br> 
                  </dd>
                </dl>
              </li>
            `).join("")}
            </ul>            
          </div>
        </div>
      </div>
    </div>`                                          
    this.popupContent.innerHTML = innerHTML;
    this.popupOverlay.style.display = "block"
  }
  
}
class NighstickPredictiveSearch extends YWM {
  constructor(options={}) {
    super(options);
    this.options = options;
    this.weaponsTag = location.pathname.split("/").pop()
    this.selectedFirearm = window.firearmsDB.flat().find(model=>model.handle==this.weaponsTag)
   
    if (selectedFirearm) {
      this.selectedFirearm = selectedFirearm
      this.selectedMake = selectedFirearm.manufacturer
      this.selectedModel = selectedFirearm.name
    } else if (this.selectedMake && this.selectedModel) {
        this.selectedFirearm = window.firearmsDB.firearmByMakeModel(this.selectedMake,this.selectedModel)
    }
    if (this.selectedFirearm) {
      this.populateModels(this.selectedMake)
    }
    this.autoCompleteHolder = document.querySelector("weapons-autocomplete")
    this.selectWeaponButton?.addEventListener(
      "click",
      event=>{
        if (this.selectedWeapon) {
          location.href=`/pages/holsters/${this.selectedWeapon.handle}`
        }
      }
    )
    document.querySelector(`#autocomplete.weapon-predictive-search`)?.addEventListener(
      "keypress",
      event=>{
        if (event.key)
        this.selectedWeapon = null;
        this.selectWeaponButton.disabled=true;
      }
    )
    let itemsToShow = this.config.limitResults?this.config.visibleResultsCount:99999999;
    const autoCompleteJS = new autoComplete({
        selector: `#autocomplete.weapon-predictive-search`,
        data: {
            src: window.firearmsDB.flat(),
        },
        cache: false, // Enable caching for data
        searchEngine:this.getMatchingFirearms,
        resultsList: {
          maxResults:itemsToShow,
          
          element: (list, data) => {
              list.classList.add("pdp-autocomplete-results")
              if (!data.results.length) {
                  const message = document.createElement('li');
                  message.setAttribute('class', 'no_result');
                  message.style.pointerEvents = "none";
                  message.innerHTML = `No results found`;
                  list.appendChild(message);
              } else {
                  let resultValues = data.results.map(result=>result.value)
                  let resultsList = ''
                  let featuredResults = resultValues.filter(result=>result.featured)
                  let standardResults = resultValues.filter(result=>!result.featured)
                  if (featuredResults.length>0) {
                      resultsList = `
                          ${this.mapAutocompleteResults(featuredResults)}
                          ${this.mapAutocompleteResults(standardResults,featuredResults.length)}
                      `

                  } else {
                      resultsList = `
                          ${this.mapAutocompleteResults(standardResults)}
                      `
                  }
                  list.innerHTML = resultsList
              }
          },
          noResults: true,
        },
        resultItem: {
          highlight: true,
          element: (item,data)=>{
              item.textContent = data.match.fullName;
          }

        },
        events: {
          input: {
            selection: (event) => {
              let autoSelected = null;
              let selectedModelName = document.querySelector(`#autoComplete_result_${event.detail.selection.index}`).textContent.trim();
              let selection = window.firearmsDB.modelByFullName(selectedModelName);
              this.DOMTarget().querySelector("#autocomplete").value=selection.fullName;
              if (selection) {
                this.selectedWeapon = selection;
                this.selectWeaponButton.disabled=false;
                if (this.options.autoNavigate) {
                  location.href=`/pages/holsters/${selection.handle}`
                }
              }
            }
          }
        }
    });
  }
  getMatchingFirearms(query,list) { 
    if (list.fullName.toLowerCase().includes(query.toLowerCase())) {
        
        return list;
    } else {
        return null;
    }
  }
  mapAutocompleteResults(list,start=0) {
        return list.map((sortedResult,index)=>`
            <li id="autoComplete_result_${index+start}" role="option">
                ${sortedResult.fullName}
            </li>
        `).join("")
    }
}
class YwmFirearmsDB {
    constructor(url) {
        this.data = null;
        this.uuid = crypto.randomUUID();
        fetch(url).then(response=>response.json()).then(db=>{
            this.data = db;
            document.dispatchEvent(new CustomEvent("ywm:database:loaded",{bubbles:true,detail:"firearms DB loaded"}));
        });
    } 
    allManufacturers() {
        return this.data.manufacturers.map(manufacturer=>manufacturer.name);
    }
    manufacturer(manufacturer) {
        return this.data.manufacturers
            .find(entry=>entry.name==manufacturer);
    }
    models(manufacturer) {
        return this.manufacturer(manufacturer).models;
    }
    modelsWithProducts(manufacturer) {
      return this.models(manufacturer).filter(model=>model.products.length>0)
    }
    flat() {
        return this.data.manufacturers.reduce((a,b)=>a.concat(b.models),[]);
    }
    modelByFullName(fullName) {
        return this.flat().find(model=>model.fullName==fullName);
    }
    productsByModel(model) {
        let products = [];
        
        model.products.forEach(productId=>{
            let products  = this.data.products.find(product=>product.id==productId);
            if (product!=null) {
                products.push(product);
            }
        });
        return products
    }

    productById(id) {
        return this.data.products.find(product=>product.id==id);
    }
    firearmByMakeModel(make,model) {
        return this.data.manufacturers.find(entry=>entry.name==make)?.models.find(entry=>entry.name==model);
    }
    firearmById(id) {
        return this.flat().find(model=>model.id==id);
    }
    productsById(id) {
        return this.productsByModel(this.firearmById(id))
    }
    productsByMakeModel(make,model) {
        return this.productsByModel(this.firearmByMakeModel(make,model));
    }
}